import { render, staticRenderFns } from "./MainMessageRecover.vue?vue&type=template&id=1c0f8582&scoped=true"
import script from "./MainMessageRecover.vue?vue&type=script&lang=js"
export * from "./MainMessageRecover.vue?vue&type=script&lang=js"
import style0 from "./MainMessageRecover.vue?vue&type=style&index=0&id=1c0f8582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0f8582",
  null
  
)

export default component.exports